import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import { v4 as uuid } from "uuid";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

// TODO: Move to Vuex Store
export async function getPois(query, currentPrincipal, cancelToken) {
  const headers = getTokenHeader();
  if (!query || typeof query !== "object") query = {};

  let i = 0;
  let totalSkip = query?.$skip || 0;

  if (query.$limit > 100) {
    i = query.$limit / 100;
    query.$limit = 100;
  } else i = 1;
  const data = { allIds: [], pois: [], total: 0 };
  if (headers) {
    while (i > 0) {
      const response = await axios.get(`${env.poi_api_client_url}poi/`, {
        params: {
          ...query,
          $skip: totalSkip,
          currentPrincipal,
          extended: true,
          backendSearch: true
        },
        headers,
        cancelToken // Pass the cancelToken to the request
      });

      data.total = response?.data?.total ?? 0;
      data.pois = data.pois.concat(response?.data?.data ?? []);
      data.allIds = data.allIds.concat(response?.data?.allIds ?? []);

      if (data.total < 100) break;
      if (data.total - data.pois?.length === 0) break;
      if (query.$limit < 100) break;
      totalSkip += 100;
      i--;
    }
    return data;
  }
}
export async function getPoisForConnectionMapping(currentPrincipal) {
  const headers = getTokenHeader();

  if (headers) {
    const response = await axios.get(
      `${env.poi_api_client_url}poi/poisForRegions`,
      {
        params: {
          principal: currentPrincipal
        },
        headers
      }
    );

    return response.data;
  }
}

export function buildQuery(options, search, filter, currentPrincipal) {
  if (!options || typeof options !== "object") options = {};
  const query = {};
  let { subPrincipals = [] } = currentPrincipal;
  subPrincipals = subPrincipals.map(principal => principal._id);

  const { itemsPerPage, page, sortBy, sortDesc, getAllIds } = options;

  /**
   * All logic here is caused by serverfunctions.
   * If this is to complicated/confusing we maybe
   * should improve the server logic.
   */

  /**
   * Logic for pagination
   * $skip: How many found items should be skipped in DB
   * $limit: How many items should be displayed
   */
  if (getAllIds) query.getAllIds = true;
  if (itemsPerPage) query.$limit = itemsPerPage || 10;
  if (page) query.$skip = itemsPerPage * (page - 1);
  if (!filter && search?.query) filter = search.query;
  if (subPrincipals?.length) {
    subPrincipals.push(currentPrincipal._id);
    query.principal = subPrincipals;
  }
  if (filter?.query) {
    filter = filter.query;
    const key = Object.keys(filter)[0];
    query[key] = [filter[key]];
    query.extended = true;
    if (Object.keys(filter)[1] === "deleted")
      query.deleted = filter[Object.keys(filter)[1]];
    else query.deleted = false;
  } else if (!filter) query.deleted = false;
  query[`$sort[${sortBy?.[0] ?? "title"}]`] = sortDesc?.[0] ? -1 : 1;
  if (search?.length >= 3) query.$search = search.toLowerCase();
  {
    return query;
  }
}

export const defaultPoi = {
  title: "",
  subTitle: "",
  shortTitle: "",
  sortTitle: "",
  category: "",
  additionalCategories: [],
  slug: "",
  manualSlug: false,
  highlight: false,
  active: true,
  name: "",
  area: "",
  nation: "",
  address: { country: "Deutschland" },
  online: {},
  webcamLinks: [{}],
  showFirst: "pictures",
  showWebcamsFirst: false,
  mainFiles: [],
  fileFiles: [],
  pictures: [],
  files: [],
  showVideoIn: "gallery",
  conferenceInfos: {
    overnightStay: false,
    completeRoomCount: 0,
    singleRoomCount: 0,
    doubleRoomCount: 0,
    moreBedsRoomCount: 0,
    minPersonsConference: 0,
    maxPersonsConference: 0,
    maxPersonsNight: 0,
    highlights: [],
    rooms: []
  },
  gastronomy: {
    seatsIndoors: undefined,
    seatsOutdoors: undefined
  },
  camping: {
    tentPitches: undefined,
    caravanPitches: undefined
  },
  highlights: [],
  jobPostings: [],
  contactPerson: {
    name: "",
    title: "",
    phoneNumber: "",
    eMail: "",
    picture: {}
  },
  exhibitions: [],
  openingHours: {
    freeAccess: true,
    closedDays: [{}],
    seasonalOpeningHours: [],
    specialDays: [{}],
    description: {
      description: "",
      seasonalDescription: "",
      arrivalInformation: "",
      hygieneNoticeText: "",
      hygieneNoticeIUrl: ""
    }
  },
  state: {
    lastAscent: "", // Zeit
    lastDescent: "", // Zeit
    firstAscent: "", // Zeit
    ascent: undefined,
    descent: undefined,
    seasonStart: "",
    seasonEnd: "",
    prognosisCountLift: undefined,
    prognosisCountTrailClassic: undefined,
    prognosisCountTrailSkating: undefined,
    prognosisCountTrail: undefined,
    prognosisLengthLift: undefined,
    prognosisLengthTrail: undefined,
    prognosisLengthTrailClassic: undefined,
    prognosisLengthTrailSkating: undefined,
    state: "openingHours",
    stateInfo: "",
    valleySnowDepth: undefined,
    mountainSnowDepth: undefined,
    avalancheLevel: "",
    lastSnowFall: "",
    freshSnow: undefined,
    capacityPerUnit: undefined,
    carriage: undefined,
    drivingTime: "",
    valleySeaLevel: undefined,
    mountainSeaLevel: undefined,
    height: undefined,
    valleyLength: undefined,
    heightDifference: undefined,
    hasSnowMaking: false,
    hasValleyRun: false,
    lakeTemperature: "",
    waterQuality: "",
    temperature: undefined,
    difficulty: "",
    trackType: "",
    walkingTime: "", // Zeit
    floodlightAt: [],
    floodlightFrom: "", // Zeit
    floodlightUntil: "", // Zeit
    lastTimeGroomed: "", // Zeit
    lastDateGroomed: "",
    length: undefined,
    lowestHeight: undefined,
    highestHeight: undefined,
    snowTexture: "",
    pathCondition: [],
    bestSeason: [],
    location: "",
    condition: undefined,
    slopeCondition: "",
    experienceFactor: undefined,
    landscapeFactor: undefined,
    weatherCondition: "",
    sight: ""
  },
  pricePackages: [
    {
      id: 1,
      services: [],
      tableTitle: "Preise"
    }
  ],
  route: {
    gpx: { title: "", url: "", id: "" },
    image: { title: "", url: "", id: "" },
    description: {
      publicTransit: "",
      startingPointDescr: "",
      parking: "",
      equipment: "",
      tip: "",
      additionalInformation: "",
      destination: "",
      directions: "",
      safetyGuidelines: "",
      trackSignage: ""
    }
  },
  currentMessage: {},
  features: [],
  seasonWeeks: [{ id: uuid() }],
  contact: {
    showContact: "address"
  },
  additionalData: [{}],
  license: {},
  geo: {},
  searchTerms: [],
  relatedPois: [],
  description: {
    description: "",
    seasonalDescription: "",
    conferenceDescription: ""
  },
  shortDescription: { description: "", seasonalDescription: "" },
  principal: "",
  regions: [],
  excursionTickers: [],
  events_module: {
    isLocation: false,
    isOperator: false,
    oploc_id: ""
  }
};

export function getListHTML(apiKey) {
  const innerHTML = `<div class="eopois-widget" id="eopois-list-widget"
     data-target-uri="https://meineseite/pois/xxxSLUGxxx"
     data-list-uri="https://meineseite/pois/"
     data-api-url="${env.poi_api_client_url}"
     data-api-key="${apiKey.apiKey}"
     data-color-text="${apiKey.color["color-text"]}"
     data-color-primary="${apiKey.color["color-primary"]}"
     data-color-secondary="${apiKey.color["color-secondary"]}"
     data-color-accent="${apiKey.color["color-accent"]}"
     data-color-error="${apiKey.color["color-error"]}"
     data-color-info="${apiKey.color["color-info"]}"
     data-color-warning="${apiKey.color["color-warning"]}"
     data-map-pin-fill-color="${apiKey.color["map-pin-fill-color"]}"
     data-map-pin-stroke-color="${apiKey.color["map-pin-stroke-color"]}"
     data-map-pin-fill-color-active="${apiKey.color["map-pin-fill-color-active"]}"
     data-map-pin-stroke-color-active="${apiKey.color["map-pin-stroke-color-active"]}"
>
    <svg xmlns="http://www.w3.org/2000/svg" width="150" viewBox="0 0 100 100">
        <circle fill="#00636C" cx="6" cy="50" r="6">
            <animateTransform attributeName="transform" dur="1s" type="translate" values="0 15 ; 0 -15; 0 15" repeatCount="indefinite" begin=".1"/>
        </circle>
        <circle fill="#00636C" cx="30" cy="50" r="6">
            <animateTransform attributeName="transform" dur="1s" type="translate" values="0 10 ; 0 -10; 0 10" repeatCount="indefinite" begin=".2"/>
        </circle>
        <circle fill="#00636C" cx="54" cy="50" r="6">
            <animateTransform attributeName="transform" dur="1s" type="translate" values="0 5 ; 0 -5; 0 5" repeatCount="indefinite" begin=".3"/>
        </circle>
    </svg>

</div>

<div class="eo-async-scripts" data-path="${env.pois_widget_api_url}">
    <div data-name="eopoi-lib-eopoi"></div>
    <div data-name="eopoi-lib-vuetify"></div>
    <div data-name="eopoi-list"></div>
</div>

<script type="module" src="${env.pois_widget_api_url}loadAsyncPois.min.js"></script>`;
  return innerHTML;
}

export function getTeaserHTML(apiKey) {
  const innerHTML = `<div class="eopoi-teaser-widget" id="eopoi-teaser1"
    data-api-url="${env.poi_api_client_url}"
    data-api-key="${apiKey.apiKey}"
    data-target-uri="https://meineseite/pois/xxxSLUGxxx"
    data-list-uri="https://meineseite/pois/">
</div>

<div class="eo-async-scripts" data-path="${env.pois_widget_api_url}">
    <div data-name="eopoi-lib-eopoi"></div>
    <div data-name="eopoi-lib-vuetify"></div>
    <div data-name="eopoi-teaser"></div>
</div>

<script type="module" src="${env.pois_widget_api_url}loadAsyncPois.min.js"></script>`;
  return innerHTML;
}

export function getDetailHTML(apiKey) {
  const innerHTML = `<div class="eopoi-teaser-widget" id="eopoi-teaser1"
    data-api-url="${env.poi_api_client_url}"
    data-api-key="${apiKey.apiKey}"
    data-target-uri="https://meineseite/pois/xxxSLUGxxx"
    data-list-uri="https://meineseite/pois/">
</div>

<div class="eo-async-scripts" data-path="${env.pois_widget_api_url}">
    <div data-name="eopoi-lib-eopoi"></div>
    <div data-name="eopoi-lib-vuetify"></div>
    <div data-name="eopoi-teaser"></div>
</div>

<script type="module" src="${env.pois_widget_api_url}loadAsyncPois.min.js"></script>`;
  return innerHTML;
}

export function getNewListHTML(apiKey) {
  const innerHTML = `<div class="eopois-widget" id="eopois-list-widget"
     data-api-url="${env.poi_api_client_url}"
     data-api-key="${apiKey.apiKey}"
     data-target-uri="https://meineseite/pois/detail/#xxxSLUGxxx"
     data-list-uri="https://meineseite/pois/"
     data-teaser-uri="https://meineseite/teaser/"
     data-color-text="${apiKey.color["color-text"]}"
     data-color-primary="${apiKey.color["color-primary"]}"
     data-color-contrast="${apiKey.color["color-contrast"]}">
</div>

<div class="eopois-async-scripts" data-path="${env.pois_widget_api_url_v2}">
    <div data-name="eopois-list"></div>
</div>
<script type="module" src="${env.pois_widget_api_url_v2}loadAsyncPois.min.js"></script>
<link href="${env.pois_widget_api_url_v2}eopois-Variables.css" rel="stylesheet" type="text/css">`;
  return innerHTML;
}

export function getNewDetailHTML(apiKey) {
  const innerHTML = `<div class="eopois-widget" id="eopois-dv-widget"
     data-api-url="${env.poi_api_client_url}"
     data-api-key="${apiKey.apiKey}"
     data-target-uri="https://meineseite/pois/detail/#xxxSLUGxxx"
     data-list-uri="https://meineseite/pois/"
     data-teaser-uri="https://meineseite/teaser/"
     data-color-text="${apiKey.color["color-text"]}"
     data-color-primary="${apiKey.color["color-primary"]}"
     data-color-contrast="${apiKey.color["color-contrast"]}"
     data-poi="mein-poi">
</div>

<div class="eopois-async-scripts" data-path="${env.pois_widget_api_url_v2}">
    <div data-name="eopois-detailView"></div>
</div>

<!-- Falls POI Slug nicht über Attribute "data-poi" gesetzt -->
<script>
    const arr = window.location.hash.split("#");
    const hash = arr[arr.length-1];
    doc = document.getElementById("eopois-dv-widget");
    doc.setAttribute('data-poi', hash);
</script>

<script type="module" src="${env.pois_widget_api_url_v2}loadAsyncPois.min.js"></script>
<link href="${env.pois_widget_api_url_v2}eopois-Variables.css" rel="stylesheet" type="text/css">`;
  return innerHTML;
}

export function getNewTeaserHTML(apiKey) {
  const innerHTML = `<div class="eopois-widget" id="eopois-teaser-widget"
     data-api-url="${env.poi_api_client_url}"
     data-api-key="${apiKey.apiKey}"
     data-target-uri="https://meineseite/pois/detail/#xxxSLUGxxx"
     data-list-uri="https://meineseite/pois/"
     data-teaser-uri="https://meineseite/teaser/"
     data-color-text="${apiKey.color["color-text"]}"
     data-color-primary="${apiKey.color["color-primary"]}"
     data-color-contrast="${apiKey.color["color-contrast"]}">
</div>

<div class="eopois-async-scripts" data-path="${env.pois_widget_api_url_v2}">
    <div data-name="eopois-teaser"></div>
</div>
<script type="module" src="${env.pois_widget_api_url_v2}loadAsyncPois.min.js"></script>
<link href="${env.pois_widget_api_url_v2}eopois-Variables.css" rel="stylesheet" type="text/css">`;
  return innerHTML;
}

export function getNewContentTeaserHTML(apiKey) {
  const innerHTML = `<div class="eopois-widget" id="eopois-content-teaser-widget"
     data-api-url="${env.poi_api_client_url}"
     data-api-key="${apiKey.apiKey}"
     data-target-uri="https://meineseite/pois/detail/#xxxSLUGxxx"
     data-list-uri="https://meineseite/pois/"
     data-teaser-uri="https://meineseite/teaser/"
     data-color-text="${apiKey.color["color-text"]}"
     data-color-primary="${apiKey.color["color-primary"]}"
     data-color-contrast="${apiKey.color["color-contrast"]}">
</div>

<div class="eopois-async-scripts" data-path="${env.pois_widget_api_url_v2}">
    <div data-name="eopois-contentTeaser"></div>
</div>
<script type="module" src="${env.pois_widget_api_url_v2}loadAsyncPois.min.js"></script>
<link href="${env.pois_widget_api_url_v2}eopois-Variables.css" rel="stylesheet" type="text/css">`;
  return innerHTML;
}

export const imports = [
  {
    typeId: "Feratel-ID",
    isActive: principal => {
      const login = principal?.additional_data?.feratelLogins;
      return login?.some(_ => _.importPois);
    }
  },
  {
    typeId: "Feratel-CPS-ID",
    isActive: principal => {
      const login = principal?.additional_data?.feratelCPSLogin;
      return login?.feedUrl?.length;
    }
  },
  {
    typeId: "OutdoorActive-ID",
    isActive: principal => {
      const login = principal?.additional_data?.outdoorActiveLogin;
      return login?.importPois || login?.importTours;
    }
  },
  {
    typeId: "Tramino-ID",
    isActive: principal => {
      const login = principal?.additional_data?.traminoLogin?.bergbahnStatus;
      return login?.active;
    }
  },
  {
    typeId: "Tramino-ID-Tourismus",
    isActive: principal => {
      const login = principal?.additional_data?.traminoLogin?.pois;
      return login?.apiUrl?.length;
    }
  },
  {
    typeId: "DestinationOne-ID",
    isActive: principal => {
      const login = principal?.additional_data?.destinationOneLogin?.pois;
      return login?.apiUrl?.length && login?.types?.length;
    }
  }
];

export const PoiSteps = [
  { title: "Beschreibung", id: "description" },
  { title: "Medien", id: "media" },
  { title: "Öffnungszeiten", id: "openingHours" },
  { title: "Preise", id: "prices" },
  { title: "Merkmale", id: "features" },
  { title: "Skigebiet Status", id: "ski" },
  { title: "Destination Status", id: "destination" },
  { title: "Lifte & Bahnen Status", id: "lift" },
  { title: "Hütten Status", id: "huts" },
  { title: "Badeseen Status", id: "lake" },
  { title: "Parkplätze Status", id: "parkingLot" },
  { title: "Pisten Status", id: "track" },
  { title: "Loipen Status", id: "trail" },
  { title: "Rodelbahn Status", id: "sledgeTrack" },
  { title: "Essen & Trinken", id: "gastronomy" },
  { title: "Camping", id: "camping" },
  { title: "Highlights", id: "highlights" },
  { title: "Tagung", id: "conference" },
  { title: "Tagungsräume", id: "conferenceRooms" },
  { title: "Stellenangebote", id: "jobPostings" },
  { title: "Veranstalter / Veranstaltungsort", id: "oploc" },
  { title: "Wandern Status", id: "hiking" },
  { title: "Allgemeiner Status", id: "state" },
  { title: "Ansprechpartner", id: "contactPerson" },
  { title: "Messe", id: "exhibition" },
  { title: "Streckenverlauf", id: "route" },
  { title: "Online-Links", id: "onlineLinks" },
  { title: "Aktuelle Nachricht", id: "latestNews" },
  { title: "Prognose", id: "excursionTickers" },
  { title: "Kontaktdaten", id: "contactData" },
  { title: "Verknüpfungen", id: "connections" },
  { title: "Urheber und Lizenz", id: "license" }
];
